<p-radioButton name="minutes"
               label="{{'timeUnits.minutes' | translate}}"
               value="minutes"
               inputId="minutes"
               [(ngModel)]="unit"
               (onClick)="onSelectUnit(TimeUnit.MINUTES)">
</p-radioButton>

<p-radioButton name="hours"
               label="{{'timeUnits.hours' | translate}}"
               value="hours"
               inputId="hours"
               [(ngModel)]="unit"
               (onClick)="onSelectUnit(TimeUnit.HOURS)">
</p-radioButton>

<p-radioButton name="days"
               label="{{'timeUnits.days' | translate}}"
               value="days"
               inputId="days"
               [(ngModel)]="unit"
               (onClick)="onSelectUnit(TimeUnit.DAYS)">
</p-radioButton>

<p-radioButton name="weeks"
               label="{{'timeUnits.weeks' | translate}}"
               value="weeks"
               inputId="weeks"
               [(ngModel)]="unit"
               (onClick)="onSelectUnit(TimeUnit.WEEKS)">
</p-radioButton>

<p-radioButton name="months"
               label="{{'timeUnits.months' | translate}}"
               value="months"
               inputId="months"
               [(ngModel)]="unit"
               (onClick)="onSelectUnit(TimeUnit.MONTHS)">
</p-radioButton>
